import React, { FC } from 'react'
import styles from './TableCell.module.scss'

type TableCellProps = React.TdHTMLAttributes<HTMLTableCellElement>

export const TableCell: FC<TableCellProps> = ({ children, ...props }) => {
  return (
    <td {...props} className={styles.tableCell}>
      {children}
    </td>
  )
}

TableCell.displayName = 'TableCell'
